import logger from "./logger";
import { notification } from "antd";

export function handleError(err: any) {
  try {
    logger.error(err);
  } catch (e) {}

  try {
    if (err?.__handledByApiInterceptor) return;

    const description =
      err?.response?.data?.message || err?.message || String(err);

    notification.error({ message: "Lỗi", description, duration: 5 });
  } catch (e) {}
}
